import React, { useState, useMemo } from 'react';
import {Switch, Route} from 'react-router-dom';
import { AppContext, GlobalState } from './AppContext';


import StartScreen from './screens/StartScreen';
import PreviousSessions from './screens/PreviousSessions';
import EnterTagNumber from './screens/EnterTagNumber';
import TailCondition from './screens/TailCondition';
import DockedArea from './screens/DockedArea';
import TailInjury from './screens/TailInjury';
import SessionSummary from './screens/SessionSummary';
import ViewAnimals from './screens/ViewAnimals';
import Receipt from './screens/Receipt';
import ActiveInjuriesSummary from './screens/ActiveInjuriesSummary';


function App() {

  const [state, setState] = useState(GlobalState.state)
  const stateValue = useMemo(() =>  ({ state, setState }), [state, setState]);

  return (
    <AppContext.Provider value={stateValue}>
    	<div className="content-container">
	        <main>
	            <Switch>
	                <Route path={["/"]} component={StartScreen} exact />
                  <Route path={["/previous_sessions"]} component={PreviousSessions} exact />
                  <Route path={["/enter_tag"]} component={EnterTagNumber} exact  />
                  <Route path={["/tail_condition"]} component={TailCondition} exact />
                  <Route path={["/docked_area"]} component={DockedArea} exact />
                  <Route path={["/tail_injury"]} component={TailInjury} exact />
                  <Route path={["/summary"]} component={SessionSummary} exact />
                  <Route path={["/receipt"]} component={Receipt} exact />
                  <Route path={["/view_animals"]} component={ViewAnimals} exact />
                  <Route path={["/active_injuries"]} component={ActiveInjuriesSummary} exact />
	            </Switch>
	        </main>
        </div>
    </AppContext.Provider>
  );
}

export default App;
